<!-- Toolbar -->
<p-fieldset [legend]="titulo" [toggleable]="false" styleClass="mb-4"> 
  <div class="flex justify-between items-center">
    <div class="flex flex-row items-center">
      <span class="pr-2">Archivo:</span>
      <input type="text" pInputText  [value]="idfdArchivo()" [fluid]="true" pSize="small" readonly />
    </div>
    <p-buttongroup>
      <p-button label="Ver" pTooltip="Ver Archivo Original" tooltipPosition="top" icon="pi pi-file-pdf" variant="outlined" size="large" (click)="viewOriginal()"/>
      <p-button label="Adicionar" pTooltip="Adicionar Archivo" tooltipPosition="top" icon="pi pi-plus" variant="outlined" size="large" (click)="addFile()"/>
      <p-button label="Previsualizar" [disabled]="!tableService.dataSelected().length" pTooltip="Vista Previa con Cambios" tooltipPosition="top" icon="pi pi-eye" variant="outlined" size="large" (click)="preview()"/>
      <p-button label="Publicar" [disabled]="!tableService.dataSelected().length" pTooltip="Publicar Nueva Versión" tooltipPosition="top" icon="pi pi-upload" variant="outlined" size="large" (click)="publish()"/>
    </p-buttongroup>
  </div>
</p-fieldset>

<!-- table -->
<app-table-generic 
  [table]="tableService.table()" 
  [data]="tableService.data()" 
  [dataSelected]="tableService.dataSelected()"
  (onConsult)="tableService.load($event)"
  (onSelected)="tableService.selected($event)"
/>